// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"168":"skill","443":"about"}[chunkId] + "." + {"168":"a6d4721a","443":"6d218fb8"}[chunkId] + ".css";
};